/*
 * @Description  :
 * @Author       : tcsl-fast-tianyu
 * @Date         : 2025-10-11
 * @LastEditors  : tcsl-fast-tianyu
 * @LastEditTime : 2025-10-13
 */
'use strict'
import { readFile } from 'fs/promises'
import type { VersionInfo } from '../types.ts'
import { GitService } from './GitService.ts'

/**
 * 默认时间格式化函数
 */
const pad = (num: number, length: number): string => {
  return String(num).padStart(length, '0')
}

const defaultTimeFormatter = (timeStamp: Date): string => {
  const year = timeStamp.getFullYear()
  const month = pad(timeStamp.getMonth() + 1, 2)
  const day = pad(timeStamp.getDate(), 2)

  const hours = pad(timeStamp.getHours(), 2)
  const minutes = pad(timeStamp.getMinutes(), 2)
  const seconds = pad(timeStamp.getSeconds(), 2)
  const milliseconds = pad(timeStamp.getMilliseconds(), 3)

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`
}

/**
 * 版本信息生成服务
 */
export class VersionInfoService {
  /**
   * 生成版本信息
   */
  static async generateVersionInfo(
    options: {
      includeGitInfo?: boolean
      includeBuildTime?: boolean
      timeFormatter?: (date: Date) => string
    } = {}
  ): Promise<Partial<VersionInfo>> {
    const {
      includeGitInfo = true,
      includeBuildTime = true,
      timeFormatter = defaultTimeFormatter,
    } = options

    const versionInfo: Partial<VersionInfo> = {}

    // 添加构建时间
    if (includeBuildTime) {
      const now = new Date()
      versionInfo.buildTime = timeFormatter(now)
      versionInfo.buildTimestamp = now.getTime()
    }

    // 添加 Git 信息
    if (includeGitInfo) {
      Object.assign(versionInfo, GitService.getAllGitInfo())
    }

    return versionInfo
  }

  /**
   * 从 package.json 获取基本信息
   */
  static async getPackageInfo(root: string): Promise<Record<string, unknown>> {
    try {
      const packageJsonPath = `${root}/package.json`
      const packageContent = await readFile(packageJsonPath, 'utf-8')
      const pkg = JSON.parse(packageContent) as Record<string, unknown>

      return {
        name: pkg['name'],
        version: pkg['version'],
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      throw new Error(`无法读取 package.json: ${errorMessage}`)
    }
  }
}
